module.exports = {"id":"181271","name":"Bořek Dočkal","rating":"75","photo":"./data/images/photos/3/181271.png","club":{"name":"Philadelphia U.","logo":"./data/images/clubs/PhiladelphiaU..png"},"positions":["MOC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BorekDockal0.json
// module id = 619
// module chunks = 0